/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useGetMemberships = (
  { page = 1, search = "", orderField = "", orderDirection = "", serviceIds = [] } = {},
  queryOptions = {}
) => {
  return useQuery({
    queryKey: queryKeys.memberships.list({ page, search, orderField, orderDirection, serviceIds }),
    queryFn: () =>
      fetcher({
        method: "GET",
        url: "/public/memberships",
        params: {
          include: "services",
          page,
          order_field: orderField,
          order_direction: orderDirection,
          ...(search ? { "filter[search]": search } : {}),
          ...(serviceIds.length ? { "filter[service_id]": serviceIds } : {}),
        },
      }),
    ...queryOptions,
  });
};
